module.exports = __webpack_public_path__ + "img/ocr2.b1b0574e.png";